import * as React from 'react';
import { Box } from 'signoxe/components/layout';
import { Button } from 'signoxe/components/widgets';
import './styles.scss';

export class AddSaveCancelWidget extends React.Component<IAddSaveCancelWidgetProps, IAddSaveCancelWidgetState> {
  public static defaultProps = {
    primary: true,
  };

  private textBox?: HTMLInputElement;

  private handleSave = () => {
    if (this.textBox) this.props.onSave(this.textBox.value);
    this.handleStopAdding();
  }
  private handleStartAdding = () => this.setState({adding: true});
  private handleStopAdding = () => this.setState({adding: false});

  constructor(props) {
    super(props);
    this.state = {adding: false};
  }

  public render() {
    if (this.state.adding) {
      return (
        <Box direction="row" className="add-save-cancel-widget editing">
          <input type="text" ref={(input: HTMLInputElement) => this.textBox = input} autoFocus/>
          <Button primary onClick={this.handleSave}>Save</Button>
          <Button secondary onClick={this.handleStopAdding}>Cancel</Button>
        </Box>
      );
    } else {
      return (
        <Button primary={this.props.primary}
                onClick={this.handleStartAdding} className="add-save-cancel-widget">
          {this.props.addLabel}
        </Button>
      );
    }
  }
}

interface IAddSaveCancelWidgetProps {
  addLabel: string;
  onSave: (...args: any[]) => any;
  primary?: boolean;
}

interface IAddSaveCancelWidgetState {
  adding: boolean;
}

export default AddSaveCancelWidget;



// WEBPACK FOOTER //
// ./src/components/widgets/AddSaveCancelWidget/index.tsx